import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-shape-file-import-dialog',
  template: `
<div class="example-container mat-elevation-z8">
  <div class="search-input">
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target['value'])" placeholder="Filter">
    </mat-form-field>
  </div>
    <table style="width: 100%" mat-table matSort [dataSource]="dataSource" class="search-input">
      <ng-container matColumnDef="{{key}}" *ngFor="let key of keys">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header>{{key}}</th>
        <td mat-cell *matCellDef="let element">{{element.properties[key]}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="keys"></tr>
      <tr class="element-row mat-row"
        mat-row
        (click)="clickRow(row)"
        [class.demo-row-is-clicked]=""
        *matRowDef="let row; columns: keys;"
      ></tr>
    </table>
</div>
  `,
  styles: ['.mat-cell {padding: 8px 8px 8px 0;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShapeFileImportDialog implements OnInit {

  @Output() onRowClick: EventEmitter<any> = new EventEmitter();

  keys = []

  ngOnInit(): void {
      if (this.geoJson?.features){
        this.keys = Object.keys(this.geoJson.features[0].properties);
        this.dataSource = new MatTableDataSource<any>(this.geoJson.features);
        this.dataSource.filterPredicate = (data: Element, filter: string) => {
          let ok = false
          this.keys.some(key => {
            // @ts-ignore
            ok = (data.properties[key]+'').toLowerCase().includes(filter)
            return ok
          })
          return ok
        };
      }
  }

  clickRow(row){
    this.onRowClick.next(row)
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim()
    filterValue = filterValue.toLowerCase()
    this.dataSource.filter = filterValue;
  }

  @Input() geoJson
  dataSource

  protected readonly Object = Object;

}
